import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Navbar from './components/layout/Navbar';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import SearchPage from './pages/SearchPage';
import SavedLeadsPage from './pages/SavedLeadsPage';
import HistoryPage from './pages/HistoryPage';
import ProfilePage from './pages/ProfilePage';
import TeamPage from './pages/TeamPage';
import AdminPage from './pages/AdminPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import AIAgentPage from './pages/AIAgentPage';
import TrySearchPage from './pages/TrySearchPage';

function WithNav({ children }) {
  return (
    <div className="app">
      <Navbar/>
      <div className="page-container">{children}</div>
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="loading-screen">
      <div className="spinner spinner-lg"/>
      <div style={{ color:'var(--text3)', fontSize:14, marginTop:12 }}>Loading LeadRadar…</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace/>;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user?.role !== 'admin') return <Navigate to="/dashboard" replace/>;
  return children;
}

export default function AppRouter() {
  const { user, loading } = useAuth();
  const hasToken = !!localStorage.getItem('lr_token');

  if (loading && hasToken) {
    return (
      <div className="loading-screen">
        <div className="spinner spinner-lg"/>
        <div style={{ color:'var(--text3)', fontSize:14, marginTop:12 }}>Loading LeadRadar…</div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public */}
      <Route path="/"             element={user ? <Navigate to="/dashboard" replace/> : <LandingPage/>}/>
      <Route path="/login"        element={user ? <Navigate to="/dashboard" replace/> : <LoginPage/>}/>
      <Route path="/register"     element={user ? <Navigate to="/dashboard" replace/> : <RegisterPage/>}/>
      <Route path="/verify-email" element={<VerifyEmailPage/>}/>
      <Route path="/try"          element={user ? <Navigate to="/search" replace/> : <TrySearchPage/>}/>

      {/* Protected */}
      <Route path="/dashboard" element={<Protected><WithNav><DashboardPage/></WithNav></Protected>}/>
      <Route path="/search"    element={<Protected><WithNav><SearchPage/></WithNav></Protected>}/>
      <Route path="/saved"     element={<Protected><WithNav><SavedLeadsPage/></WithNav></Protected>}/>
      <Route path="/agent"     element={<Protected><WithNav><AIAgentPage/></WithNav></Protected>}/>
      <Route path="/history"   element={<Protected><WithNav><HistoryPage/></WithNav></Protected>}/>
      <Route path="/profile"   element={<Protected><WithNav><ProfilePage/></WithNav></Protected>}/>
      <Route path="/team"      element={<Protected><WithNav><TeamPage/></WithNav></Protected>}/>
      <Route path="/team/accept" element={<TeamPage/>}/>

      {/* Admin */}
      <Route path="/admin/*"   element={<Protected><AdminOnly><WithNav><AdminPage/></WithNav></AdminOnly></Protected>}/>

      {/* Catch-all */}
      <Route path="*"          element={<Navigate to="/" replace/>}/>
    </Routes>
  );
}


// import React, { useEffect } from 'react';
// import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
// import { useAuth } from './context/AuthContext';
// import Navbar         from './components/layout/Navbar';
// import LandingPage    from './pages/LandingPage';
// import LoginPage      from './pages/LoginPage';
// import RegisterPage   from './pages/RegisterPage';
// import VerifyEmailPage from './pages/VerifyEmailPage';
// import DashboardPage  from './pages/DashboardPage';
// import SearchPage     from './pages/SearchPage';
// import SavedLeadsPage from './pages/SavedLeadsPage';
// import HistoryPage    from './pages/HistoryPage';
// import ProfilePage    from './pages/ProfilePage';
// import AdminPage      from './pages/AdminPage';
// import TeamPage       from './pages/TeamPage';
// import AcceptInvitePage from './pages/AcceptInvitePage';
// import PricingPage    from './pages/PricingPage';

// function NavigateSetter() {
//   const nav = useNavigate();
//   useEffect(() => { window.__navigate = nav; return () => { window.__navigate = null; }; }, [nav]);
//   return null;
// }

// function Protected({ children }) {
//   const { user, loading } = useAuth();
//   if (loading) return <div className="loading-screen"><div className="spinner spinner-lg"/><div style={{ color:'var(--text3)', fontSize:14 }}>Loading LeadRadar…</div></div>;
//   if (!user) return <Navigate to="/login" replace/>;
//   return children;
// }

// function AdminOnly({ children }) {
//   const { user } = useAuth();
//   if (user?.role !== 'admin') return <Navigate to="/dashboard" replace/>;
//   return children;
// }

// function WithNav({ children }) {
//   return (
//     <div className="app">
//       <Navbar/>
//       <div className="page-container">{children}</div>
//     </div>
//   );
// }

// export default function AppRouter() {
//   const { user } = useAuth();
//   return (
//     <>
//       <NavigateSetter/>
//       <Routes>
//         <Route path="/"               element={user ? <Navigate to="/dashboard"/> : <LandingPage/>}/>
//         <Route path="/pricing"        element={<PricingPage/>}/>
//         <Route path="/login"          element={user ? <Navigate to="/dashboard"/> : <LoginPage/>}/>
//         <Route path="/register"       element={user ? <Navigate to="/dashboard"/> : <RegisterPage/>}/>
//         <Route path="/verify-email"   element={<VerifyEmailPage/>}/>
//         <Route path="/dashboard"      element={<Protected><WithNav><DashboardPage/></WithNav></Protected>}/>
//         <Route path="/search"         element={<Protected><WithNav><SearchPage/></WithNav></Protected>}/>
//         <Route path="/saved"          element={<Protected><WithNav><SavedLeadsPage/></WithNav></Protected>}/>
//         <Route path="/history"        element={<Protected><WithNav><HistoryPage/></WithNav></Protected>}/>
//         <Route path="/profile"        element={<Protected><WithNav><ProfilePage/></WithNav></Protected>}/>
//         <Route path="/team"           element={<Protected><WithNav><TeamPage/></WithNav></Protected>}/>
//         <Route path="/team/accept"    element={<WithNav><AcceptInvitePage/></WithNav>}/>  {/* public — no Protected wrapper */}
//         <Route path="/admin/*"        element={<Protected><AdminOnly><WithNav><AdminPage/></WithNav></AdminOnly></Protected>}/>
//         <Route path="*"               element={<Navigate to="/" replace/>}/>
//       </Routes>
//     </>
//   );
// }